module.exports = __webpack_public_path__ + "img/Dr-Juan-Heron-Sanchez-Hermosillo.b298425d.jpg";